<div class="dpos-registry-container">
  <!-- Breadcrumb -->
  <div class="mb-4">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{
        icon: 'pi pi-home',
        routerLink: '/axa/professionals-personal-info',
        ariaLabel: 'Home',
      }"
    >
    </p-breadcrumb>
  </div>

  <!-- Cards Area -->
  <section class="cards-area">
    @if (showGeneralDataCard()) {
      <app-professionals-general-data></app-professionals-general-data>
    }
  </section>

  <!-- Toast for notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />
</div>
